export default "__VITE_PUBLIC_ASSET__453675c0__"